<template>
  <div class="paymentHistory">
    <van-nav-bar
      :title="title"
      left-arrow
      safe-area-inset-top
      @click-left="$router.go(-1)"
    ></van-nav-bar>
    <div v-if="flag">
      <bill-list
        v-for="item in bilList"
        :key="item.id || item.trade_no"
        :billist="item"
        :show-pay="type !== '3'"
        @paid="load"
      ></bill-list>
    </div>
    <div class="zero" v-else>
      <img src="../assets/img/zw.png" alt="" />
    </div>
  </div>
</template>

<script>
import BillList from '@/components/Bills.vue'
import { bills, repayments } from '@/api/request.js'
export default {
  name: 'BillDetail',
  data() {
    return {
      bilList: [],
      type: ''
    }
  },
  components: { BillList },
  computed: {
    flag() {
      return this.bilList.length
    },
    title() {
      switch (this.type) {
        case '1':
          return '七日待还'
        case '2':
          return '全部待还'
        case '3':
          return '还款记录'
        default:
          return '账单'
      }
    }
  },
  methods: {
    withinSevenDays(dueDate) {
      if (!dueDate) return true
      const due = new Date(dueDate + 'T00:00:00').getTime()
      const now = Date.now()
      const diff = due - now
      return diff <= 7 * 24 * 3600 * 1000
    },
    async load() {
      this.type = String(this.$route.query.num || '2')
      if (this.type === '3') {
        const res = await repayments()
        this.bilList = (res.data || []).map((r) => ({
          id: r.id,
          trade_no: r.trade_no,
          period: r.period,
          product_name: r.contract_no,
          amount: r.amount,
          paid_amount: r.amount,
          status: 'paid',
          paid_at: r.created_at,
          repaymentStatus: 2,
          repaymentNum: r.amount,
          repaymentTime: r.created_at
        }))
        return
      }
      const res = await bills('pending')
      let list = res.data || []
      if (this.type === '1') {
        list = list.filter((b) => this.withinSevenDays(b.due_date))
      }
      this.bilList = list
    }
  },
  created() {
    this.load()
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/public";
.paymentHistory {
  .van-nav-bar {
    background-image: linear-gradient(to right, #6aa8f5, #3d8aef);
    /deep/ .van-nav-bar__title {
      color: #fff;
    }
    /deep/ .van-icon {
      color: #fff;
    }
  }
  .zero {
    margin-top: 2.13rem;
    text-align: center;
    img {
      width: 2.48rem;
      margin: 0 auto;
    }
  }
}
</style>
